//// komal and rishab code
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { useState, useEffect, useRef } from "react";
import { Button, DateBox, LoadPanel, SelectBox } from "devextreme-react";
import ScrollView from "devextreme-react/scroll-view";
import DataGrid, {
  Column,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Toolbar,
} from "devextreme-react/data-grid";
import { Item } from "devextreme-react/toolbar";
import React from "react";
import BreadCrumb from "../../components/breadCrumb/BreadCrumb";
import CustomDropdown from "../../components/customDropDown/CustomDropdown";
import CustomTextBox from "../../components/customTextBox/CustomTextBox";
import {
  HeaderText,
  SubText,
} from "../../components/typographyText/TypographyText";
import "./LogReports.scss";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import { fetchLogReports } from "../../api/logReportsApi";

export default function LogReports() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const logReportDatagridRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [reportDataSource, setReportDataSource] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedLogLevel, setSelectedLogLevel] = useState(null);
  const [selectedLoginUser, setSelectedLoginUser] = useState(null);
  const [selectedUserRole, setSelectedUserRole] = useState(null);
  const [moduleOptions, setModuleOptions] = useState([]);
  const [methodOptions, setMethodOptions] = useState([]);
  const [logLevelOptions, setLogLevelOptions] = useState([]);
  const [loginUserOptions, setLoginUserOptions] = useState([]);
  const [userRoleOptions, setUserRoleOptions] = useState([]);
  const [displayedTicketCount, setDisplayedTicketCount] = useState(0);

  const updateDisplayedTicketCount = () => {
    if (logReportDatagridRef.current?.instance) {
      const totalCount = logReportDatagridRef.current.instance.totalCount();
      setDisplayedTicketCount(totalCount || 0);
    }
  };

  const getData = async () => {
    try {
      setLoading(true);
      const response = await fetchLogReports(user?.companytransid);
      if (response?.message === "API logs retrieved successfully") {
        const formattedData = response?.data || [];
        setReportDataSource(formattedData);

        const uniqueModules = new Set();
        const uniqueMethods = new Set();
        const uniqueLogLevels = new Set();
        const uniqueLoginUsers = new Set();
        const uniqueUserRoles = new Set();

        formattedData.forEach((log) => {
          if (log.module) uniqueModules.add(log.module);
          if (log.methodname) uniqueMethods.add(log.methodname);
          if (log.loglevel) {
            const logLevelFormatted =
              log.loglevel === "E"
                ? "Error"
                : log.loglevel === "I"
                  ? "Info"
                  : log.loglevel;
            uniqueLogLevels.add(logLevelFormatted);
          }
          if (log.loginuser) uniqueLoginUsers.add(log.loginuser);
          const roleLabelMap = {
            Company: "Quantum Admin",
            User: "Quantum Users",
            Customer: "Client",
          };

          const userRoleOptions = [
            { value: "All", text: "All" },
            ...[...uniqueUserRoles].map((role) => ({
              value: role,
              text: roleLabelMap[role] || role, // fallback if new role comes
            })),
          ];

          setUserRoleOptions(userRoleOptions);
          if (log.userrole) uniqueUserRoles.add(log.userrole);
          console.log("users : ", uniqueUserRoles);
        });

        const formatOptions = (set) =>
          [{ value: "All", text: "All" }].concat(
            [...set].map((item) => ({ value: item, text: item })),
          );

        setModuleOptions(formatOptions(uniqueModules));
        setMethodOptions(formatOptions(uniqueMethods));
        setLogLevelOptions(formatOptions(uniqueLogLevels));
        setLoginUserOptions(formatOptions(uniqueLoginUsers));
        // setUserRoleOptions(formatOptions(uniqueUserRoles));
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error.response?.data?.error || "Failed to fetch data",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleModule = (newFilter) => {
    const filterValue = newFilter === "All" ? null : newFilter;
    if (logReportDatagridRef.current && logReportDatagridRef.current.instance) {
      logReportDatagridRef.current.instance.columnOption(
        "Module",
        "filterValue",
        filterValue,
      );
      logReportDatagridRef.current.instance.refresh();
    }
  };

  const handleMethod = (newFilter) => {
    const filterValue = newFilter === "All" ? null : newFilter;
    if (logReportDatagridRef.current && logReportDatagridRef.current.instance) {
      logReportDatagridRef.current.instance.columnOption(
        "Method Name",
        "filterValue",
        filterValue,
      );
      logReportDatagridRef.current.instance.refresh();
    }
  };

  const handleLogLevel = (newFilter) => {
    const filterValue =
      newFilter === "All"
        ? null
        : newFilter === "Error"
          ? "E"
          : newFilter === "Info"
            ? "I"
            : newFilter;

    if (logReportDatagridRef.current && logReportDatagridRef.current.instance) {
      logReportDatagridRef.current.instance.columnOption(
        "Log Level",
        "filterValue",
        filterValue,
      );
      logReportDatagridRef.current.instance.refresh();
    }
  };

  const handleLoginUser = (newFilter) => {
    const filterValue = newFilter === "All" ? null : newFilter;
    if (logReportDatagridRef.current && logReportDatagridRef.current.instance) {
      logReportDatagridRef.current.instance.columnOption(
        "Login User",
        "filterValue",
        filterValue,
      );
      logReportDatagridRef.current.instance.refresh();
    }
  };

  const handleUserRole = (newFilter) => {
    const filterValue = newFilter === "All" ? null : newFilter;
    if (logReportDatagridRef.current && logReportDatagridRef.current.instance) {
      logReportDatagridRef.current.instance.columnOption(
        "User Role",
        "filterValue",
        filterValue,
      );
      logReportDatagridRef.current.instance.refresh();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleReset = () => {
    // Reset dropdown states
    setSelectedModule(null);
    setSelectedMethod(null);
    setSelectedLogLevel(null);
    setSelectedLoginUser(null);
    setSelectedUserRole(null);
  };

  return (
    <>
      {loading && <LoadPanel visible={loading} />}
      <div className="wholePage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-database-line"></i>
              </span>
              <p>Log Reports</p>
            </div>
            <div className="totalTicketTitle">
              <SubText
                text={`Apply filters to view log records based on module, method, user, and log level`}
              />
            </div>
          </div>
        </div>
        <div className="reportsMain">
          <div className="topHeader">
            <div className="MyTextBox">
              <CustomDropdown
                // width={230}
                label={"Module"}
                myDataSource={moduleOptions}
                placeholder={"Select Module"}
                value={selectedModule}
                setSelectedValue={(selected) => {
                  const value = selected?.value || null;

                  setSelectedModule(value);
                  handleModule(value);
                }}
              />
            </div>
            <div className="MyTextBox">
              <CustomDropdown
                // width={230}
                label={"Method"}
                myDataSource={methodOptions}
                placeholder={"Select Method"}
                value={selectedMethod}
                setSelectedValue={(selected) => {
                  const value = selected?.value || null;
                  setSelectedMethod(value);
                  handleMethod(value);
                }}
              />
            </div>
            <div className="MyTextBox">
              <CustomDropdown
                // width={230}
                label={"Log Level"}
                myDataSource={logLevelOptions}
                placeholder={"Select Log Level"}
                value={selectedLogLevel}
                setSelectedValue={(selected) => {
                  const value = selected?.value || null;
                  setSelectedLogLevel(value);
                  handleLogLevel(value);
                }}
              />
            </div>
            <div className="MyTextBox">
              <CustomDropdown
                // width={230}
                label={"Login User"}
                myDataSource={loginUserOptions}
                placeholder={"Select Login User"}
                value={selectedLoginUser}
                setSelectedValue={(selected) => {
                  const value = selected?.value || null;
                  setSelectedLoginUser(value);
                  handleLoginUser(value);
                }}
              />
            </div>
            <div className="MyTextBox">
              <CustomDropdown
                // width={230}
                label={"User Role"}
                myDataSource={userRoleOptions}
                placeholder={"Select Userrole"}
                value={selectedUserRole}
                setSelectedValue={(selected) => {
                  const value = selected?.value || null;
                  setSelectedUserRole(value);
                  handleUserRole(value);
                }}
              />
            </div>
            {/* <div className="MyTextBox"> */}
            <Button
              width={100}
              height={46}
              text="Reset"
              type="default"
              onClick={handleReset}
            />
            {/* </div> */}
          </div>

          <div
            className="botSection "
            style={{ height: "calc(100vh - 350px)" }}
          >
            <div className="ReportDatagrid">
              <DataGrid
                style={{ height: "calc(100vh - 360px)" }}
                width={"100%"}
                className={"ticketGrid reportsGrid"}
                dataSource={reportDataSource}
                columnAutoWidth={true}
                columnHidingEnabled={true}
                ref={logReportDatagridRef}
                onContentReady={updateDisplayedTicketCount}
              >
                <Toolbar>
                  <Item location="before">
                    <div style={{ fontWeight: "600", fontSize: "18px" }}>
                      <SubText text={`Total ${displayedTicketCount} records`} />
                    </div>
                  </Item>
                  <Item location="after" name="searchPanel" />
                  {/*
                  <Item location="after">
                    <SelectBox
                      id="filterStatus"
                      width={"170px"}
                      height="44px"
                      className="selectboxStatus custom-status-dropdown"
                      valueExpr="value"
                      displayExpr="text"
                      stylingMode="outlined"
                      items={statusDataSource}
                      // value={1}
                      defaultValue={1}
                      // onValueChanges={(e) => onSelectionChanged(e.value)}
                    />
                  </Item> */}
                  {/* <Item location="after">
                    <Button
                      stylingMode="outlined"
                      text="Export to Excel"
                      className="exportBtn"
                      height={"44px"}
                    />
                  </Item> */}
                </Toolbar>

                <SearchPanel
                  visible={true}
                  width={window.innerWidth <= 480 ? "80%" : "100%"}
                  placeholder="Search Records"
                />

                <Selection mode="multiple" showCheckBoxesMode="always" />
                <Pager
                  visible={true}
                  // allowedPageSizes={[10, 20, 30]}
                  // showPageSizeSelector={true}
                />
                <Paging defaultPageSize={"none"} />
                <Scrolling mode="virtual" />
                {/* <Column dataField="transid" caption="TransID" /> */}
                <Column dataField="module" caption="Module" />
                <Column dataField="viewname" caption="View Name" />
                <Column dataField="methodname" caption="Method Name" />
                <Column
                  dataField="loglevel"
                  caption="Log Level"
                  cellRender={(data) => {
                    return data.value === "I"
                      ? "Info"
                      : data.value === "E"
                        ? "Error"
                        : data.value;
                  }}
                />
                <Column dataField="logmessage" caption="Log Message" />
                <Column
                  dataField="jsonpayload"
                  caption="JSON Pay Load"
                  hidingPriority={0}
                  cellRender={(data) => {
                    if (!data.value) return "-";
                    let formattedJSON;
                    try {
                      formattedJSON = JSON.stringify(
                        JSON.parse(data.value),
                        null,
                        2,
                      );
                    } catch (error) {
                      return "Invalid JSON data";
                    }
                    return (
                      <>
                        <ScrollView
                          showScrollbar="onHover"
                          scrollByContent={true}
                          direction="both"
                        >
                          <pre
                            style={{
                              cursor: "text",
                              maxHeight: "20px",
                              fontSize: "12px",
                            }}
                          >
                            {formattedJSON}
                          </pre>
                        </ScrollView>
                      </>
                    );
                  }}
                />
                <Column dataField="loginuser" caption="Login User" />
                <Column
                  dataField="userrole"
                  caption="User Role"
                  hidingPriority={3}
                  cellRender={(data) => {
                    const role = data.value;

                    const roleMap = {
                      Company: "Quantum Admin",
                      User: "Quantum Users",
                      Customer: "Client",
                    };

                    return <span>{roleMap[role] || role}</span>;
                  }}
                />
                <Column
                  dataField="entrydate"
                  caption="Entry Date"
                  hidingPriority={2}
                />
                <Column
                  dataField="cmptransid"
                  caption="Cmp Trans ID"
                  hidingPriority={1}
                />
              </DataGrid>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
